module.exports = __webpack_public_path__ + "img/ALL-COVER.7d40c56b.png";